import React, {FC, memo, useCallback, useState} from "react";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import MainLabel from "../../component/mainLabel/MainLabel";
import {AuthContainer, Border} from "../auth/login/LoginStyle";
import {ButtonGroup} from "./RegistrationStyle";
import FormCode from "../../component/formCode/FormCode";
import {IToken} from "../../store/sliceToken";
import {fetchRegistration, IRegistration} from "../../fetch/AuthRequest";
import {actions} from "../../store/sliceModal";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {config} from "../../config";
import {useNavigate} from "react-router-dom";

interface IValidation {
    isInvalid: boolean,
    isValid: boolean,
    value: string
}

const Registration: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const nav = useNavigate();
    const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const loginRegex: RegExp = new RegExp("[а-яА-Я]", "g");

    const [inputCode, setInputCode] = useState(false)
    const [token, setToken] = useState({} as IToken)


    const [name, setName] = useState({} as IValidation);
    const [login, setLogin] = useState({} as IValidation);
    const [loginError, setLoginError] = useState(false);
    const [password, setPassword] = useState({} as IValidation);
    const [email, setEmail] = useState({} as IValidation);


    const validationField = useCallback((value: string, func: React.Dispatch<React.SetStateAction<IValidation>>) => {
        if (value.length > 0) {
            func({
                value: value,
                isValid: true,
                isInvalid: false
            } as IValidation)
        } else {
            func({
                value: value,
                isValid: false,
                isInvalid: false
            } as IValidation)
        }
    }, [name, password])

    const validationLogin = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        event.target.value = event.target.value.replaceAll(loginRegex,"")
        const value = event.target.value
        if (value.length > 0) {
            setLogin({
                value: value,
                isValid: true,
                isInvalid: false
            } as IValidation)
        } else {
            setLogin({
                value: value,
                isValid: false,
                isInvalid: false
            } as IValidation)
        }
        if (login.isValid) {
            setLoginError(false)
        }
    }, [login])

    const validationEmail = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (emailRegex.test(event.target.value)) {
            setEmail({
                value: event.target.value,
                isValid: true,
                isInvalid: false
            } as IValidation)
        } else {
            setEmail({
                value: event.target.value,
                isValid: false,
                isInvalid: false
            } as IValidation)
        }
    }, [email])


    const clearFields =() => {
        setName({} as IValidation)
        setLogin({} as IValidation)
        setPassword({} as IValidation)
        setEmail({} as IValidation)

    }

    const validationForm = useCallback( () => {
        if (!name.isValid) {
            setName({...name, isInvalid: true})
        }
        if (!login.isValid) {
            setLogin({...login, isInvalid: true})
        }
        if (!password.isValid) {
            setPassword({...password, isInvalid: true})
        }

        if (!email.isValid) {
            setEmail({...email, isInvalid: true})
        }

        return name.isValid && login.isValid && password.isValid && email.isValid
    }, [name, login, password, email])

    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!validationForm()) {
            return;
        }

        fetchRegistration({
            name: name.value,
            login: login.value,
            password: password.value,
            email: email.value
        } as IRegistration).then((response) => {

            if (response.status === 200) {
                setToken(response.data)
                setInputCode(true);
                clearFields()
                nav(`${config.uiStart}/code`)
            } else if (response.status === 400) {
                setLogin({...login, isValid: false, isInvalid: true})
                setLoginError(true)
            } else {
                dispatch(actions.showError(response.data))
            }

        })
    }, [name, email, password, login]);

    return (

        <Container as={"main"}>
            <AuthContainer>
                <Border>
                    <MainLabel/>
                    {!inputCode && <Form noValidate onSubmit={handleSubmit}>
                        <Row style={{flexDirection: "column", gap: "10px"}}>
                            <Form.Group as={Col} controlId="validationCustom01">
                                <Form.Label>Имя</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="Имя"
                                    isValid={name.isValid}
                                    isInvalid={name.isInvalid}
                                    onChange={(event) => validationField(event.target.value, setName)}
                                />
                                <Form.Control.Feedback type="invalid">Введите имя</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col}  controlId="validationCustom02">
                                <Form.Label>Логин</Form.Label>
                                <Form.Control
                                   required
                                    type="text"
                                    placeholder="Логин"
                                   isValid={login.isValid}
                                   isInvalid={login.isInvalid}
                                   onChange={validationLogin}
                                />
                                {!loginError && <Form.Control.Feedback type="invalid">Введите логин</Form.Control.Feedback>}
                                {loginError && <Form.Control.Feedback type="invalid">Пользователь с таким логином уже существует</Form.Control.Feedback>}
                            </Form.Group>

                            <Form.Group as={Col} controlId="validationCustom03">
                                <Form.Label>Пароль</Form.Label>
                                <Form.Control
                                    required
                                    type="password"
                                    placeholder="Пароль"
                                    isValid={password.isValid}
                                    isInvalid={password.isInvalid}
                                    onChange={(event) => validationField(event.target.value, setPassword)}
                                />
                                <Form.Control.Feedback type="invalid">Введите пароль</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="validationCustom04" style={{marginBottom: "10px"}}>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="Email"
                                    isValid={email.isValid}
                                    isInvalid={email.isInvalid}
                                    onChange={validationEmail}
                                />
                                <Form.Control.Feedback type="invalid">Ошибка ввода email</Form.Control.Feedback>

                            </Form.Group>
                            <ButtonGroup >
                                <Button variant="outline-primary" type={"submit"}>Зарегистрироваться</Button>
                            </ButtonGroup>
                        </Row>
                    </Form>}
                    {/*{inputCode && <FormCode token={token} rollback={() => setInputCode(false)}/>}*/}
                </Border>
            </AuthContainer>
        </Container>
    )
}

export default memo(Registration)
